export enum BeApiServiceEnum {
	TAGS_SERVICE = "tagsService",
	SEO_INFO_SERVICE = "seoInfoService",
	USER_INFO_SERVICE = "userInfoService",
	URL_REDIRECT_SERVICE = "urlRedirectService"
}
